/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Bell_Object_LinesheetInputs */

const en_bell_object_linesheet = /** @type {(inputs: Bell_Object_LinesheetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linesheet ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Linesheet {reference}" |
*
* @param {Bell_Object_LinesheetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_object_linesheet = /** @type {((inputs: Bell_Object_LinesheetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Object_LinesheetInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_object_linesheet(inputs)
});